import React from 'react';

import env from '@travel/env';
import type { Props } from '@travel/traveler-core/components/Media';
import MediaCore from '@travel/traveler-core/components/Media';

export type { MediaType } from '@travel/traveler-core/components/Media';

const VPF_REF_ID_PREFIX = env('UNIVERSAL_VPF_REF_ID_PREFIX');
const VPF_SID = env('UNIVERSAL_VPF_SID');

function Media(props: Props) {
  const { media: mediaProps, ...restProps } = props;
  const videoId = mediaProps?.videoId;
  const media = {
    ...mediaProps,
    refId: videoId ? `${VPF_REF_ID_PREFIX}-${videoId?.slice(-5)}` : undefined,
    serviceId: VPF_SID,
  };

  return (
    <MediaCore
      media={media}
      hasControls={true}
      data-testid="media-item"
      isDisableSrcSetCache={true}
      {...restProps}
    />
  );
}

export default React.memo(Media);
